export class LegalNoticeMessages {
  public titre = 'mentions_legales.titre';
  public serviceTitre = 'mentions_legales.service_titre';
  public serviceTexteDebut = 'mentions_legales.service_texte_debut';
  public serviceTexteLien = 'mentions_legales.service_texte_lien';
  public serviceTexteFin = 'mentions_legales.service_texte_fin';
  public serviceUrl = 'mentions_legales.service_url';

  public adresseTitre = 'mentions_legales.adresse_titre';
  public adresseNom = 'mentions_legales.adresse_nom';
  public adresseLigne1 = 'mentions_legales.adresse_ligne1';
  public adresseLigne2 = 'mentions_legales.adresse_ligne2';
  public adresseLigne3 = 'mentions_legales.adresse_ligne3';

  public realisationEditorialeTitre = 'mentions_legales.realisation_editoriale_titre';
  public realisationEditorialeTexte = 'mentions_legales.realisation_editoriale_texte';

  public directeurPublicationTitre = 'mentions_legales.directeur_publication_titre';
  public directeurPublicationNom = 'mentions_legales.directeur_publication_nom';

  public realisationTitre = 'mentions_legales.realisation_titre';
  public realisationNom = 'mentions_legales.realisation_nom';
  public realisationAdresse = 'mentions_legales.realisation_adresse';
  public realisationVille = 'mentions_legales.realisation_ville';

  public exploitationTitre = 'mentions_legales.exploitation_titre';
  public exploitationNom = 'mentions_legales.exploitation_nom';
  public exploitationLigne1 = 'mentions_legales.exploitation_ligne1';
  public exploitationLigne2 = 'mentions_legales.exploitation_ligne2';
  public exploitationLigne3 = 'mentions_legales.exploitation_ligne3';

  public hebergementTitre = 'mentions_legales.hebergement_titre';
  public hebergementNom = 'mentions_legales.hebergement_nom';
  public hebergementAdresse = 'mentions_legales.hebergement_adresse';
  public hebergementCodePostal = 'mentions_legales.hebergement_code_postal';

  public droitsReproductionTitre = 'mentions_legales.droits_reproduction_titre';
  public droitsReproductionCopie = 'mentions_legales.droits_reproduction_copie';
  public droitsReproductionLiens = 'mentions_legales.droits_reproduction_liens';

  public nousJoindreTitre = 'mentions_legales.nous_joindre_titre';
  public nousJoindreTexte = 'mentions_legales.nous_joindre_texte';
  public nousJoindreUrl = 'mentions_legales.nous_joindre_url';
  public nousJoindreUrlIntitule = 'mentions_legales.nous_joindre_url_intitule';

  constructor() {
  }
}
